import React from "react";
import { FiSliders } from "react-icons/fi";
import { useTranslation } from "lib/i18n/use-translation";
// Deliberately reuses the chat-history button's styles so the QA-mode button
// is visually identical — in QA mode it takes the history button's place.
import styles from "./OriHistoryButton.module.scss";

interface OriQaPanelButtonProps {
  onClick: () => void;
}

const OriQaPanelButton: React.FC<OriQaPanelButtonProps> = ({ onClick }) => {
  const { t } = useTranslation(["ori"]);
  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      aria-label={t("ori:qa.panelLabel")}
      data-testid="ori-qa-open"
    >
      <FiSliders className={styles.icon} aria-hidden />
      <span className={styles.label}>{t("ori:qa.panelLabel")}</span>
    </button>
  );
};

export default OriQaPanelButton;
